const { BASE_PATH } = require('../../../../lib/basePath.js');

// Strip the BASE_PATH from pathname to get the relative route
function getRelativePath() {
    const pathname = window.location.pathname;
    if (BASE_PATH && pathname.startsWith(BASE_PATH)) {
        return pathname.slice(BASE_PATH.length) || '/';
    }
    return pathname;
}

function onQuizPage() {
    return getRelativePath() === '/quiz-spacer-by-cbre';
}

function onHomePage() {
    const relativePath = getRelativePath();
    return relativePath === '/' || relativePath.indexOf('/referral') > -1;
}

function onResultsForIdPage() {
    const relativePath = getRelativePath();
    const onOldResultsPageForIdRegex = /^\/results\/.+/;
    const onNewResultsPageForIdRegex = /^\/program-your-results-spacer-by-cbre\/.+/;
    return (onOldResultsPageForIdRegex.test(relativePath) || onNewResultsPageForIdRegex.test(relativePath));
}

module.exports = {
    onQuizPage,
    onHomePage,
    onResultsForIdPage
};
